/* assets/hero-peek.js */
(function () {
  const CDN_CSS = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css";
  const CDN_JS  = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";

  function loadAsset(tag, attrs) {
    return new Promise((resolve, reject) => {
      const el = document.createElement(tag);
      Object.entries(attrs).forEach(([k, v]) => (el[k] = v));
      el.onload = resolve;
      el.onerror = reject;
      (document.head || document.body).appendChild(el);
    });
  }

  async function ensureSwiper() {
    if (typeof window.Swiper !== "undefined") return;
    // load CSS then JS
    await loadAsset("link", { rel: "stylesheet", href: CDN_CSS });
    await loadAsset("script", { src: CDN_JS, async: true });
  }

  function toInt(val, fallback) {
    const n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }
  function toBool(val) {
    return String(val) === "true";
  }

  function initOne(sliderEl) {
    if (!sliderEl || sliderEl.dataset.initialized === "true") return;

    // Read data-* (from the section)
    const slideW       = toInt(sliderEl.dataset.slideWidth, 1200);
    const fixedH       = toInt(sliderEl.dataset.fixedHeight, 500);
    const spaceBetween = toInt(sliderEl.dataset.spaceBetween, 24);
    const autoplay     = toBool(sliderEl.dataset.autoplay);
    const autoplayDelay= toInt(sliderEl.dataset.autoplayDelay, 3500);
    const loop         = toBool(sliderEl.dataset.loop);
    const speed        = toInt(sliderEl.dataset.speed, 600);
    const showPag      = toBool(sliderEl.dataset.pagination);
    const showArrows   = toBool(sliderEl.dataset.arrows);

    // Reflect CSS variables (width/height) from settings
    sliderEl.style.setProperty("--slide-w", slideW + "px");
    sliderEl.style.setProperty("--fix-h",   fixedH + "px");

    const container = sliderEl.querySelector(".kvPeekSwiper");
    if (!container) return;

    // Scoped controls
    const pagEl   = sliderEl.querySelector(".hero-peek-pagination");
    const nextEl  = sliderEl.querySelector(".swiper-button-next");
    const prevEl  = sliderEl.querySelector(".swiper-button-prev");

    /* eslint-disable no-new */
    new Swiper(container, {
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween,
      loop,
      speed,
      autoplay: autoplay
        ? { delay: autoplayDelay, disableOnInteraction: false }
        : false,
      pagination: showPag && pagEl ? { el: pagEl, clickable: true } : false,
      navigation: showArrows && nextEl && prevEl
        ? { nextEl, prevEl }
        : false,
      watchOverflow: true,
      breakpoints: {
        0:   { spaceBetween: 12 },
        768: { spaceBetween }
      }
    });

    sliderEl.dataset.initialized = "true";
  }

  async function initAll() {
    const sliders = document.querySelectorAll(".hero-peek-wrap");
    if (!sliders.length) return;
    await ensureSwiper();
    sliders.forEach(initOne);
  }

  // Run on normal pages
  document.addEventListener("DOMContentLoaded", initAll);

  // Run inside Theme Editor when sections are reloaded
  document.addEventListener("shopify:section:load", initAll);
})();
